import { Controller } from '@hotwired/stimulus';
import { useEventListener } from 'stimulus-library/dist';

export default class extends Controller {
  static values = {
    keys: Array,
  };

  get keys() {
    return Array.from(this.keysValue).map((key) => key.toLowerCase());
  }

  connect() {
    useEventListener(this, this.element, 'keypress', this.handleKeyDown);
  }

  handleKeyDown(event) {
    if (this.keys.includes(event.key.toLowerCase())) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
